import type {
  ActionResult,
  PennylaneInvoiceDetail,
  PennylaneInvoiceListItem,
  PennylaneManualByIdResult,
} from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/**
 * Couche réseau des **factures Pennylane vues depuis Commandes** (`02` §3) :
 * la fiche facture et ses actions de ligne. Les réglages et les runs Pennylane
 * vivent ailleurs (Paramètres › Pennylane, Journal › Runs).
 */

export function fetchInvoiceDetail(id: string): Promise<PennylaneInvoiceDetail> {
  return apiFetch<PennylaneInvoiceDetail>(`/api/pennylane/invoices/${id}`);
}

/** « Mettre à jour depuis Pennylane » : relecture et aperçu recalculé, rien n'est envoyé. */
export function refreshInvoice(id: string): Promise<ActionResult> {
  return apiFetch<ActionResult>(`/api/pennylane/invoices/${id}/refresh`, { method: 'POST' });
}

/** « Renvoyer la facture à Martelet » : retraitement depuis Pennylane, nouveau fichier, envoi. */
export function resendInvoice(id: string, confirmResend: boolean): Promise<PennylaneInvoiceListItem> {
  return apiFetch<PennylaneInvoiceListItem>(`/api/pennylane/invoices/${id}/resend`, {
    method: 'POST',
    body: { confirmResend },
  });
}

export function forceSendInvoice(id: string): Promise<PennylaneInvoiceListItem> {
  return apiFetch<PennylaneInvoiceListItem>(`/api/pennylane/invoices/${id}/force`, { method: 'POST' });
}

export function ignoreInvoice(id: string, reason: string): Promise<PennylaneInvoiceListItem> {
  return apiFetch<PennylaneInvoiceListItem>(`/api/pennylane/invoices/${id}/ignore`, {
    method: 'POST',
    body: { reason },
  });
}

/** « Importer… » depuis Commandes, origine Pennylane : par numéro ou id de facture. */
export function importInvoiceByNumber(
  idOrNumber: string,
  confirmResend: boolean,
): Promise<PennylaneManualByIdResult> {
  return apiFetch<PennylaneManualByIdResult>('/api/pennylane/manual/invoice', {
    method: 'POST',
    body: { idOrNumber, confirmResend },
  });
}
